import ErrorBoundary from './ErrorBoundary';
import IgnoreChildrenOnFatalError from './IgnoreChildrenOnFatalError';

export { IgnoreChildrenOnFatalError };
export default ErrorBoundary;
